/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Observable} from 'rxjs';
import {ProductCustomer} from './ProductCustomer';
import {CartProduct} from './CartProduct';
import {CustomProduct} from './CustomProduct';
import {CartProductReplace} from './CartProductReplace';

export interface Cart {
  cart: CartProduct[];
  add(product: ProductCustomer, amount: number): Observable<CartProduct>;
  addCustom(product: CustomProduct): Observable<CartProduct>;
  recount(cartProduct: CartProduct, amount: number): Observable<CartProduct>;
  addList(cartProductList: CartProduct[]): Observable<CartProduct[]>;
  clear(): Observable<any>;
  find(product: ProductCustomer): Observable<CartProduct>;
  get(): Observable<CartProduct[]>;
  getShareCart(syncUid: string): Observable<CartProduct[]>;
  getByRegion( region: number): Observable<CartProduct[]>;
  getStoreCart(): CartProduct[];
  remove(cartProduct: CartProduct): Observable<any>;
  replace(cartProductReplace: CartProductReplace): Observable<any>;
}
